import {cva} from 'class-variance-authority';

export const buttonVariants = cva(
  `relative inline-flex shrink-0 items-center justify-center rounded-full border border-transparent text-center font-urbanist transition-colors before:absolute before:rounded-full before:content-[''] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed [&>svg]:shrink-0`,
  {
    variants: {
      variant: {
        default: `
          text-action
          hover:text-action-hover
          active:text-action-active
          focus-visible:text-action-active
          disabled:text-disabled
        `,
        primary: `
          bg-primary-700 text-on-action
          hover:bg-primary-600
          active:bg-primary-800
          focus-visible:bg-primary-800
          disabled:bg-neutral-300 disabled:text-on-disabled
        `,
        secondary: `
          border-action text-action
          hover:border-action-hover hover:text-action-hover
          active:border-action-active active:text-action-active
          focus-visible:border-action-active focus-visible:text-action-active
          disabled:border-disabled disabled:text-disabled
        `,
        tertiary: `
          text-action
          hover:text-action-hover
          active:text-action-active
          focus-visible:text-action-active
          disabled:text-disabled
        `,
        warning: `
          text-danger-500
          hover:text-danger-400
          active:text-danger-600
          focus-visible:text-danger-600
          disabled:text-danger-200
        `,
        link: `
          text-action
          hover:text-action-hover
          active:text-action-active
          focus-visible:text-action-active
          disabled:text-disabled
        `,
        ['link-accent']: `
          text-secondary-800
          hover:text-secondary-600
          active:text-secondary-900
          focus-visible:text-secondary-900
          disabled:text-secondary-200
        `,
      },
      size: {
        default:
          'h-11 gap-2 px-6 py-2 type-btn-default leading-[22px] [&>svg]:size-6',
        medium:
          'h-11 gap-2 px-6 py-2 type-btn-default leading-[22px] [&>svg]:size-6',
        small:
          'h-9 gap-1 px-4 type-btn-sm leading-5 before:inset-x-0 before:-inset-y-1 [&>svg]:size-4',
        large: 'h-13 gap-2 px-6 py-3 type-btn-lg leading-6 [&>svg]:size-8',
        text: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
